import React from "react";
import "./AIAnomaliesModal.scss";
import {
  MotifModal,
  MotifModalHeader,
  MotifModalBody,
} from "@ey-xd/motif-react";
import { AILogo } from "../../assets/Icons/SparksSolid";
import { AI_ANOMALIES_DATA } from "./reviewMappingsDummyData";

// Arrow icon for "Go to field" button
const ArrowRightIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.25 3.5L8.75 7L5.25 10.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// Modal component for displaying AI Anomalies Summaries
export const AIAnomaliesModal = ({
  show,
  onClose,
  onGoToField,
  anomalies = AI_ANOMALIES_DATA,
}) => {
  const handleGoToField = (anomaly) => {
    if (onGoToField) {
      onGoToField(anomaly);
    }
    // Optionally close modal after navigation
    // onClose();
  };

  return (
    <MotifModal
      show={show}
      onClose={onClose}
      size="lg"
      className="ai-anomalies-modal"
    >
      <MotifModalHeader>
        <div className="ai-anomalies-header">
          <AILogo width={20} height={20} color="#FFE600" />
          <span>AI Anomalies Summaries</span>
        </div>
      </MotifModalHeader>
      <MotifModalBody>
        <div className="ai-anomalies-list">
          {anomalies.map((anomaly) => (
            <div key={anomaly.id} className="ai-anomaly-card">
              <div className="anomaly-header">
                <h3 className="anomaly-field-name">{anomaly.fieldName}</h3>
                <span className="anomaly-file-tag">
                  {anomaly.sheetName ? `${anomaly.fileName} - ${anomaly.sheetName}` : anomaly.fileName}
                </span>
              </div>
              <p className="anomaly-description">{anomaly.description}</p>
              <div className="anomaly-values">
                {/* <div className="value-group">
                  <span className="value-label">Current Value</span>
                  <span className="value-text current">{anomaly.currentValue}</span>
                </div> */}
                <div className="value-group">
                  <span className="value-label">AI Suggested Value</span>
                  <span className="value-text suggested">{anomaly.aiSuggestedValue}</span>
                </div>
                {/* <button 
                  className="go-to-field-btn"
                  onClick={() => handleGoToField(anomaly)}
                >
                  Go to field
                  <ArrowRightIcon />
                </button> */}
              </div>
            </div>
          ))}
        </div>
      </MotifModalBody>
    </MotifModal>
  );
};

export default AIAnomaliesModal;
